
      import API from "!../../../../node_modules/.pnpm/style-loader@3.0.0_webpack@5.100.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/.pnpm/style-loader@3.0.0_webpack@5.100.1/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import getTarget from "!../../../../node_modules/.pnpm/style-loader@3.0.0_webpack@5.100.1/node_modules/style-loader/dist/runtime/getTarget.js";
      import insertStyleElement from "!../../../../node_modules/.pnpm/style-loader@3.0.0_webpack@5.100.1/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import content, * as namedExport from "!!../../../../node_modules/.pnpm/css-loader@5.2.6_webpack@5.100.1/node_modules/css-loader/dist/cjs.js!./quill.mention.css";
      
      

var options = {};

options.styleTagTransform = function(css, style){
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
      while (style.firstChild) {
        style.removeChild(style.firstChild);
      }

      style.appendChild(document.createTextNode(css));
    }
  };
options.setAttributes = function(style) {
        var nonce =
          typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;

        if (nonce) {
          style.setAttribute("nonce", nonce);
        }
      };
options.insert = function(style){
    var target = getTarget("head");

    if (!target) {
      throw new Error(
        "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
      );
    }

    target.appendChild(style);
  };
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/.pnpm/css-loader@5.2.6_webpack@5.100.1/node_modules/css-loader/dist/cjs.js!./quill.mention.css";
       export default content && content.locals ? content.locals : undefined;
